<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_687" data-name="Rectangle 687" width="284.327" height="213.985" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="How_C-suite_executives_choose_their_partners" data-name="How C-suite executives choose
their partners" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">How C-suite executives choose</tspan>
        <tspan x="0" y="28">their partners</tspan>
    </text>
    <text id="_Talent_and_experience_Ability_to_articulate_a_clear_point_of_view_on_key_business_or_industry_trends_"
          data-name="•  Talent and experience
•  Ability to articulate a clear
    point of view on key
    business or industry trends
" transform="translate(40 201)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23" xml:space="preserve">•  Talent and experience</tspan>
        <tspan x="0" y="51" xml:space="preserve">•  Ability to articulate a clear </tspan>
        <tspan x="0" y="79" xml:space="preserve">    point of view on key</tspan>
        <tspan x="0" y="107" xml:space="preserve">    business or industry trends</tspan>
    </text>
    <text id="CEO" transform="translate(40 101)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric"
          font-weight="700">
        <tspan x="0" y="81">CEO</tspan>
    </text>
    <g id="Group_1352" data-name="Group 1352" transform="translate(70 370)">
        <g id="Group_1346" data-name="Group 1346" clip-path="url(#clip-path)">
            <path id="Path_14650" data-name="Path 14650"
                  d="M162.1,212.97a27.555,27.555,0,0,0-23.085-27.186,28.282,28.282,0,0,1-34.373-.167A27.551,27.551,0,0,0,80.348,212.97"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14651" data-name="Path 14651"
                  d="M96.476,159.367A25.521,25.521,0,1,1,122,184.889,25.522,25.522,0,0,1,96.476,159.367Z" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14652" data-name="Path 14652"
                  d="M121.222,59.982l9.8,19.86,21.917,3.184L137.081,98.485l3.744,21.827-19.6-10.305-19.6,10.305,3.744-21.827L89.5,83.026l21.917-3.184Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14653" data-name="Path 14653" d="M197.283,126.639v86.346H45.161V96.394" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14654" data-name="Path 14654" d="M45.161,37.137V22.581H177.117" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14655" data-name="Path 14655"
                  d="M275.217,86.71a23.894,23.894,0,0,0-.716-7.2l7-6.417-5.257-8.744L267.2,67.506a47.078,47.078,0,0,0-6.319-4.029l-.769-9.464-10.129-1.219-3.062,9.077a44.009,44.009,0,0,0-4.287,1.221,23.892,23.892,0,0,0-2.289,1.03l-7.835-5.41-7.356,7.07,5.105,8.141a24.092,24.092,0,0,0-2.467,6.767l-9.114,2.752.941,10.16,9.555,1.085a21.825,21.825,0,0,0,3.745,6.147l-3.531,8.842,8.53,5.6,6.8-6.792a24.04,24.04,0,0,0,7.151.916l4.7,8.26,9.695-3.178-1.067-9.55a23.811,23.811,0,0,0,5.176-5.024l9.388,1.472,3.56-9.561ZM265,86.438a13.8,13.8,0,1,1-12.31-15.149A13.8,13.8,0,0,1,265,86.438Z"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14656" data-name="Path 14656"
                  d="M221.2,50.245l9.859,1.465,3.654-10.059-8.55-5.288a25.019,25.019,0,0,0-.811-7.543l7.288-6.79L227.055,12.9l-9.461,3.385a49.451,49.451,0,0,0-6.662-4.173l-.886-9.921L199.411,1l-3.135,9.547a45.966,45.966,0,0,0-4.486,1.316,25.681,25.681,0,0,0-2.393,1.1l-8.263-5.608-7.656,7.477,5.422,8.5a25.232,25.232,0,0,0-2.53,7.118l-9.537,2.963L167.9,44.056l10.031,1.058a22.932,22.932,0,0,0,3.98,6.417l-3.629,9.3,8.994,5.8,7.08-7.181a25.206,25.206,0,0,0,7.508.9l5,8.625,10.142-3.416-1.2-10.007A24.964,24.964,0,0,0,221.2,50.245ZM199.661,49.2a14.478,14.478,0,1,1,15.787-13.039A14.478,14.478,0,0,1,199.661,49.2Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14657" data-name="Path 14657"
                  d="M55.369,77.532,65.228,79l3.654-10.059-8.55-5.288a25.016,25.016,0,0,0-.811-7.543l7.288-6.791-5.587-9.127-9.461,3.385A49.363,49.363,0,0,0,45.1,39.4l-.886-9.92L33.578,28.286l-3.135,9.547a46.357,46.357,0,0,0-4.486,1.315,26.211,26.211,0,0,0-2.393,1.1L15.3,34.639,7.645,42.117l5.422,8.5a25.237,25.237,0,0,0-2.53,7.119L1,60.695,2.072,71.342,12.1,72.4a22.919,22.919,0,0,0,3.98,6.418l-3.629,9.3,8.994,5.8,7.08-7.181a25.237,25.237,0,0,0,7.508.9l5,8.625L51.181,92.85l-1.2-10.006A24.987,24.987,0,0,0,55.369,77.532ZM33.828,76.488A14.478,14.478,0,1,1,49.615,63.45,14.477,14.477,0,0,1,33.828,76.488Z"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14658" data-name="Path 14658"
                  d="M206.716,91.432l5.011-6.391L206.072,78.4l-7.193,3.924a40.211,40.211,0,0,0-5.894-2.518l-1.969-7.879-8.717.383-1.318,8.087a37.541,37.541,0,0,0-3.446,1.628,20.533,20.533,0,0,0-1.789,1.188l-7.365-3.472-5.221,6.991,5.443,6.158a20.54,20.54,0,0,0-1.138,6.054l-7.307,3.593,2.211,8.442,8.213-.417a18.685,18.685,0,0,0,4.018,4.665l-1.746,7.953,7.978,3.535,4.794-6.68a20.551,20.551,0,0,0,6.161-.225l5.122,6.314,7.738-4.034-2.233-7.909a20.384,20.384,0,0,0,3.668-4.961l8.126-.067,1.671-8.565-7.556-3.178A20.418,20.418,0,0,0,206.716,91.432ZM188.6,111.1a11.8,11.8,0,1,1,11.066-12.5A11.806,11.806,0,0,1,188.6,111.1Z"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
    </g>
</svg>
